var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnenrollBulkImportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68848 19.2188L31.4993 32.4195L54.1551 19.2962",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.499 55.8254V32.3945",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3244 23.6885V38.3103C56.3244 38.4394 56.3245 38.5427 56.2987 38.6718C54.4903 37.096 52.1653 36.1661 49.582 36.1661C47.1536 36.1661 44.9061 37.0186 43.1236 38.4394C40.747 40.3252 39.2486 43.2444 39.2486 46.4994C39.2486 48.4369 39.7911 50.2711 40.7469 51.8211C40.9794 52.2344 41.2636 52.6219 41.5736 52.9836L36.8462 55.5928C33.9012 57.2461 29.0961 57.2461 26.1511 55.5928L12.3561 47.9461C9.2303 46.2152 6.67285 41.8753 6.67285 38.3103V23.6885C6.67285 20.1235 9.2303 15.7836 12.3561 14.0527L26.1511 6.40602C29.0961 4.75268 33.9012 4.75268 36.8462 6.40602L50.6412 14.0527C53.767 15.7836 56.3244 20.1235 56.3244 23.6885Z",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9167 46.4993C59.9167 48.4368 59.3742 50.271 58.4184 51.821C57.8759 52.751 57.1783 53.5777 56.3775 54.2493C54.5692 55.8768 52.1925 56.8327 49.5833 56.8327C45.8117 56.8327 42.5308 54.8177 40.7483 51.821C39.7925 50.271 39.25 48.4368 39.25 46.4993C39.25 43.2443 40.7483 40.3252 43.125 38.4394C44.9075 37.0185 47.155 36.166 49.5833 36.166C55.2925 36.166 59.9167 40.7902 59.9167 46.4993Z",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3458 49.1852L46.8691 43.7344",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.295 43.8125L46.8184 49.2633",
    stroke: "#0C80F3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnenrollBulkImportIcon);
export default __webpack_public_path__ + "static/media/unenroll_bulk_import_icon.2a5afa8be0c488e32083777adef3b466.svg";
export { ForwardRef as ReactComponent };